/* eslint-disable no-undef */
/* eslint-disable consistent-return */
import isEmpty from 'lodash/isEmpty';
import gtm from 'general/js/gtm';
import * as types from './action-types';
import * as userAccountApi from '../api/user-account-api';
import * as apiResponseMessages from './api-response-messages';
import * as messageHelper from './helpers/message-helper';
import * as dataFormatHelper from './helpers/data-format-helper';
import { beginApiCall, apiCallError } from './api-status-actions';
import { formMessageConstants } from '../../components/utils/constants/form-message-constants';
import { formConstants } from '../../components/utils/constants/form-constants';
import { redirect } from '../api/api-utils';
import { domainConstants } from '../../components/utils/constants/domain-constants';
import pageSpinner from '../../../../general/js/page-spinner';
import { hasValue } from '../../../../general/js/general-helpers';
import userService from '../../../../general/js/user/user-service';
import * as cookieHelper from '../../helpers/cookie-helper';
import { CookieNames } from '../../../../general/js/utils/cookies';
import { USER_ID } from '../../../../general/js/user/constants';

export function loadHomePageTicketsDataSuccess(homePageTicketsData) {
    return { type: types.LOAD_HOME_PAGE_TICKETS_DATA_SUCCESS, homePageTicketsData };
}

export function loadHomePageTicketsDataError(loadHomePageTicketsDataErrorMessages) {
    return { type: types.LOAD_HOME_PAGE_TICKETS_DATA_ERROR, loadHomePageTicketsDataErrorMessages };
}

export function loadUserDataSuccess(userAccountData, isAccountPageRefresh = false) {
    const data = { userAccountData, isAccountPageRefresh };

    return {
        type: types.LOAD_USER_DATA_SUCCESS, data
    };
}

export function loadUserDataError(isUserNotSignedIn) {
    return { type: types.LOAD_USER_DATA_ERROR, isUserNotSignedIn };
}

export function loadOrderHistorySuccess(orderHistoryData, displayCancelledFiles) {
    return { type: types.LOAD_ORDER_HISTORY_SUCCESS, orderHistoryData, displayCancelledFiles };
}

export function loadOrderHistoryError(loadOrderHistoryErrorMessages) {
    return { type: types.LOAD_ORDER_HISTORY_ERROR, loadOrderHistoryErrorMessages };
}

export function loadOrderHistoryPagesSuccess(orderHistoryPages, displayCancelledFiles) {
    return { type: types.LOAD_ORDER_HISTORY_PAGES_SUCCESS, orderHistoryPages, displayCancelledFiles };
}

export function loadOrderHistoryPagesError(loadOrderHistoryPagesErrorMessages) {
    return { type: types.LOAD_ORDER_HISTORY_PAGES_ERROR, loadOrderHistoryPagesErrorMessages };
}

export function loadOrderDetailsSuccess(orderDetails) {
    return { type: types.LOAD_ORDER_DETAILS_SUCCESS, orderDetails };
}

export function loadOrderDetailsError(loadOrderDetailsErrorMessages) {
    return { type: types.LOAD_ORDER_DETAILS_ERROR, loadOrderDetailsErrorMessages };
}

export function loadUserTicketsSuccess(userTicketsData, hideOldTickets) {
    return { type: types.LOAD_USER_TICKETS_SUCCESS, userTicketsData, hideOldTickets };
}

export function loadUserTicketsError(loadUserTicketsErrorMessages) {
    return { type: types.LOAD_USER_TICKETS_ERROR, loadUserTicketsErrorMessages };
}

export function downloadPdfFileSuccess() {
    return { type: types.DOWNLOAD_PDF_FILE_SUCCESS };
}

export function downloadPdfFileError(downloadPdfFileErrorMessages) {
    return { type: types.DOWNLOAD_PDF_FILE_ERROR, downloadPdfFileErrorMessages };
}

export function updateUserDetailsSuccess(updateUserDetailsMessages) {
    return { type: types.UPDATE_USER_DETAILS_SUCCESS, updateUserDetailsMessages };
}

export function resumePaymentByFileNumberError(errorMessages) {
    return { type: types.RESUME_PAYMENT_BY_FILE_NUMBER_ERROR, errorMessages };
}

export function resumePaymentByFileNumberSuccess(errorMessages) {
    return { type: types.RESUME_PAYMENT_BY_FILE_NUMBER_SUCCESS, errorMessages };
}

export function updateUserEmailSuccess(updateUserDetailsMessages) {
    return { type: types.UPDATER_USER_EMAIL_SUCCESS, updateUserDetailsMessages };
}

export function updateUserDetailsError(updateUserDetailsMessages) {
    return { type: types.UPDATE_USER_DETAILS_ERROR, updateUserDetailsMessages };
}

export function removeUserAccountSuccess() {
    return { type: types.REMOVE_USER_ACCOUNT_SUCCESS };
}

export function removeUserAccountError(removeUserAccountWithTicketsMessage) {
    return { type: types.REMOVE_USER_ACCOUNT_ERROR, removeUserAccountWithTicketsMessage };
}

export function updateUserAddressesSuccess(updateUserAddressesMessages) {
    return { type: types.UPDATE_USER_ADDRESSES_SUCCESS, updateUserAddressesMessages };
}

export function updateUserAddressesError(updateUserAddressesMessages) {
    return { type: types.UPDATE_USER_ADDRESSES_ERROR, updateUserAddressesMessages };
}

export function resetAddressesFormState() {
    return { type: types.RESET_USER_ADDRESSES_FORM_STATE };
}

export function displayUserAddressesErrorMessage(errorMessages) {
    return { type: types.USER_ADDRESSES_ERROR_MESSAGE, errorMessages };
}

export function resetUserDetailsFormState() {
    return { type: types.RESET_USER_DETAILS_FORM_STATE };
}

export function changePasswordSuccess(changePasswordMessages) {
    return { type: types.CHANGE_PASSWORD_SUCCESS, changePasswordMessages };
}

export function changePasswordError(changePasswordMessages) {
    return { type: types.CHANGE_PASSWORD_ERROR, changePasswordMessages };
}

export function resetHomePageTicketsDataFormState() {
    return { type: types.RESET_HOME_PAGE_TICKETS_DATA_FORM_STATE };
}

export function saveUserToAddressBookFormState() {
    return { type: types.SAVE_USER_TO_ADDRESS_BOOK_SUCCESS };
}

export function saveUserToAddressBookErrorMessages(errorMessages) {
    return { type: types.SAVE_USER_TO_ADDRESS_BOOK_ERROR_MESSAGE, errorMessages };
}

export function toggleDisplayCancelledFiles() {
    return {
        type: types.TOGGLE_DISPLAY_CANCELLED_FILES
    };
}

export function toggleHideOldTickets() {
    return {
        type: types.TOGGLE_HIDE_OLD_TICKETS
    };
}

export function loadUserReferralCodeSuccess(userReferralCodeData) {
    return { type: types.LOAD_REFERRAL_CODE_SUCCESS, userReferralCodeData };
}

export function loadUserReferralCodeError(loadReferralCodeErrorMessages) {
    return { type: types.LOAD_REFERRAL_CODE_ERROR, loadReferralCodeErrorMessages };
}

export function getHomePageTicketsData(callbackUrl, ssoDomain, secuTixErrorMessage) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getHomePageTicketsData(callbackUrl, ssoDomain)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));

                    if (ssoDomain === domainConstants.womensOpen) {
                        dispatch(loadHomePageTicketsDataError([secuTixErrorMessage || formMessageConstants.encounteredAnIssueWO]));
                    } else {
                        dispatch(loadHomePageTicketsDataError([secuTixErrorMessage || formMessageConstants.encounteredAnIssueTO]));
                    }

                    return;
                }
                const ticketsData = response.data || {};
                const homePageTicketsData = dataFormatHelper.getFormattedHomePageTicketsData(ticketsData, ssoDomain);
                dispatch(loadHomePageTicketsDataSuccess(homePageTicketsData));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                if (ssoDomain === domainConstants.womensOpen) {
                    dispatch(loadHomePageTicketsDataError([secuTixErrorMessage || formMessageConstants.encounteredAnIssueWO]));
                } else {
                    dispatch(loadHomePageTicketsDataError([secuTixErrorMessage || formMessageConstants.encounteredAnIssueTO]));
                }
                throw error;
            });
    };
}

export function resetHomePageTicketsData() {
    return function (dispatch) {
        dispatch(resetHomePageTicketsDataFormState());
    };
}

export function getUserAccountData(callbackUrl, isAccountPageRefresh = false) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getUserAccountData(callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    const isUserNotSignedIn = response.statusCode === messageHelper.UNAUTHORIZED_STATUS_CODE;
                    const errorMessages = isUserNotSignedIn ? [apiResponseMessages.NO_CURRENT_USER_MESSAGE] :
                        [apiResponseMessages.SERVER_ERROR_MESSAGE];
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadUserDataError(errorMessages), isUserNotSignedIn);
                    return;
                }
                dispatch(loadUserDataSuccess(response.data, isAccountPageRefresh));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                const isUserNotSignedIn = error === apiResponseMessages.NO_CURRENT_USER_MESSAGE;
                const errorMessages = isUserNotSignedIn ? [apiResponseMessages.NO_CURRENT_USER_MESSAGE] :
                    [apiResponseMessages.SERVER_ERROR_MESSAGE];
                dispatch(loadUserDataError(errorMessages), isUserNotSignedIn);
                throw error;
            });
    };
}

export function getOrderHistory(callbackUrl,
    { pageNumber, displayCancelledFiles, ssoDomain }) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getUserOrderHistoryData(callbackUrl,
            { pageNumber, displayCancelledFiles, ssoDomain })
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadOrderHistoryError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                const orderHistoryData = dataFormatHelper.getFormattedOrders(response.data.orders);
                dispatch(loadOrderHistorySuccess(orderHistoryData, displayCancelledFiles));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadOrderHistoryError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function getOrderHistoryPages(callbackUrl,
    { displayCancelledFiles, ssoDomain }) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getOrderHistoryPages(callbackUrl, { displayCancelledFiles, ssoDomain })
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadOrderHistoryPagesError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                dispatch(loadOrderHistoryPagesSuccess(response.data, displayCancelledFiles));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadOrderHistoryPagesError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function getOrderDetails(callbackUrl,
    { fileNumber, ssoDomain }) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getOrderDetails(callbackUrl, { fileNumber, ssoDomain })
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadOrderDetailsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                const orderDetailsData = dataFormatHelper.getFormattedOrderDetails(response.data);
                dispatch(loadOrderDetailsSuccess(orderDetailsData));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadOrderDetailsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function getUserTickets(callbackUrl, hideOldTickets, ssoDomain) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getUserTicketsData(callbackUrl, hideOldTickets, ssoDomain)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadUserTicketsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                dispatch(loadUserTicketsSuccess(response.data.eventTickets, hideOldTickets));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadUserTicketsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function downloadTicketPdf(callbackUrl, printOptions, ssoDomain) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.downloadPdfFile(callbackUrl, {
            ticketId: printOptions.ticketForPrint.ticketId,
            firstName: printOptions.firstNameValue,
            lastName: printOptions.lastNameValue,
            [formConstants.website]: ssoDomain
        }).then((response) => {
            if (response.hasErrors) {
                dispatch(apiCallError([response.errorMessage]));
                dispatch(downloadPdfFileError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                return;
            }

            dispatch(downloadPdfFileSuccess());
        })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(downloadPdfFileError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function downloadPdfDocumentById(callbackUrl, printOptions) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.downloadPdfFile(callbackUrl, printOptions)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(downloadPdfFileError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                dispatch(downloadPdfFileSuccess());
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(downloadPdfFileError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function updateUserAddresses(userDetails, actionSuccessText, callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateUserDetails(dataFormatHelper.getFormattedUserDetailsAddressesData(userDetails), callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(updateUserAddressesError(serverErrorMessages));
                    return;
                }
                dispatch(updateUserAddressesSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(updateUserAddressesError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function updateUserDetails({
    userDetails,
    accountData,
    actionSuccessText,
    callBackUrl,
    emailChangedConflictMessage
}) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateUserDetails(dataFormatHelper.getFormattedUserDetailsData(userDetails, accountData), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    const errorMessages = isEmpty(emailChangedConflictMessage) ?
                        serverErrorMessages :
                        [emailChangedConflictMessage];

                    dispatch(apiCallError(errorMessages));
                    dispatch(updateUserDetailsError(errorMessages));
                    return;
                }

                if (response.data && response.data.updatedUserEmailChanged) {
                    dispatch(updateUserEmailSuccess([actionSuccessText]));
                    return;
                }

                dispatch(updateUserDetailsSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(updateUserDetailsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function joinTheOneClub({
    userDetails,
    accountData,
    actionSuccessText,
    callBackUrl
}) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateUserDetails(dataFormatHelper.getFormattedJoinTheOneClubData(userDetails, accountData), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(updateUserDetailsError(serverErrorMessages));
                    return;
                }
                dispatch(updateUserDetailsSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(updateUserDetailsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function updateUserEmailNotificationSettings({
    userDetails,
    accountData,
    actionSuccessText,
    callBackUrl
}) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.updateEmailNotificationSettings(dataFormatHelper.getFormattedNotificationSettingsData(userDetails, accountData), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(updateUserDetailsError(serverErrorMessages));
                    return;
                }
                dispatch(updateUserDetailsSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(updateUserDetailsError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function removeAccount(callbackUrl) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.removeAccount(callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(removeUserAccountError([response.errorMessage]));
                    return;
                }
                dispatch(removeUserAccountSuccess());
                userService.removeDataFromLocalStorage(USER_ID);
                cookieHelper.removeCookie(CookieNames.UserId);
                gtm.push('Delete Account', 'Delete Account Success', window.location.href);
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(removeUserAccountError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function changeUserPassword(passwordDetails, actionSuccessText, callbackUrl) {
    let serverErrorMessages = [formMessageConstants.somethingWentWrong];

    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.changeUserPassword(passwordDetails, callbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    serverErrorMessages = messageHelper.getServerErrorMessages(response);
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(changePasswordError(serverErrorMessages));
                    return;
                }
                dispatch(changePasswordSuccess([actionSuccessText]));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(changePasswordError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}

export function displayVerifyUserEmail() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getVerifyEmailForm()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    return;
                }
                dispatch(changePasswordSuccess(['Email changed successfully!']));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                throw error;
            });
    };
}


export function handleRedirectToResaleTickets({
    resaleTicketsUrl,
    secutixResaleUrl,
    secutixPointOfSaleId,
    secutixVirtualOperator,
    redirectUri
}) {
    return function (dispatch) {
        pageSpinner.show();
        return userAccountApi.authUserInResaleSecutix({
            resaleTicketsUrl,
            requestUrl: secutixResaleUrl,
            secutixPointOfSaleId,
            secutixVirtualOperator,
            redirectUri
        })
            .then(() => {
                pageSpinner.hide();
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                pageSpinner.hide();
                throw error;
            });
    };
}

export function handleRedirectToRAMembersPortal({
    raMembersPortalUrl,
    secutixRAMemberPortalUrl,
    secutixPointOfSaleId,
    secutixVirtualOperator,
    redirectUri
}) {
    return function (dispatch) {
        pageSpinner.show();
        return userAccountApi.authUserInRAMembersPortalSecutix({
            raMembersPortalUrl,
            requestUrl: secutixRAMemberPortalUrl,
            secutixPointOfSaleId,
            secutixVirtualOperator,
            redirectUri
        })
            .then(() => {
                pageSpinner.hide();
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                pageSpinner.hide();
                throw error;
            });
    };
}

export function resumePaymentByFileNumber(urls, request) {
    const { resumePaymentCallbackUrl, secutixAuthUrl } = urls;

    return function (dispatch) {
        dispatch(beginApiCall());

        const promises = [];

        const resumePaymentPromise = userAccountApi.resumePaymentByFileNumber(resumePaymentCallbackUrl, request)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(resumePaymentByFileNumberError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                return response;
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(resumePaymentByFileNumberError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });

        promises.push(resumePaymentPromise);

        const authPromise = userAccountApi.authUserInSecutix(secutixAuthUrl).then((authResponse) => {
            if (authResponse.hasErrors) {
                dispatch(apiCallError([response.errorMessage]));
                dispatch(resumePaymentByFileNumberError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                return;
            }

            return authResponse;
        }).catch((error) => {
            dispatch(apiCallError([error]));
            dispatch(resumePaymentByFileNumberError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
            throw error;
        });

        promises.push(authPromise);

        Promise.all(promises).then((responseValues) => {
            let redirectUrl = responseValues[1].data.redirectUrl;

            redirectUrl = redirectUrl.replace('{0}', responseValues[0].data.orderId);
            redirectUrl = redirectUrl.replace('{1}', responseValues[0].data.orderToken);

            redirect(redirectUrl);
            dispatch(resumePaymentByFileNumberSuccess(['Reservation resumed successful!']));
        });
    };
}

export function saveUserToAddressBook(formData, accountData) {
    return function (dispatch) {
        const serverErrorMessages = [formMessageConstants.somethingWentWrong];
        const formattedRequestModel = dataFormatHelper.getFormattedSaveUserToAddressBookRequest(formData, accountData);

        if (!hasValue(formattedRequestModel) || formattedRequestModel.AddressBookID === 0) {
            dispatch(saveUserToAddressBookErrorMessages(serverErrorMessages));
            return;
        }

        const { saveUserToDotDigitalCallbackUrl } = formData;

        if (!hasValue(saveUserToDotDigitalCallbackUrl)) {
            dispatch(saveUserToAddressBookErrorMessages(serverErrorMessages));
            return;
        }

        dispatch(beginApiCall());
        return userAccountApi.saveUserToAddressBook(formattedRequestModel, saveUserToDotDigitalCallbackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(saveUserToAddressBookErrorMessages([response.errorMessage]));
                    return;
                }
                dispatch(saveUserToAddressBookFormState());
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(saveUserToAddressBookErrorMessages(error));
                throw error;
            });
    };
}

export function getUserReferralCode(callbackUrl, email) {
    return function (dispatch) {
        dispatch(beginApiCall());
        return userAccountApi.getUserReferralCode(callbackUrl, email)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadUserReferralCodeError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                    return;
                }

                dispatch(loadUserReferralCodeSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadUserReferralCodeError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                throw error;
            });
    };
}
